// 🚨 **The one escape for a value interpolated into a markup string — `TODO.md` U-93.**
//
// `$("#mainModal").html('<h4>' + name + '</h4>')` takes the value straight out of every escaping layer the
// app has: the server escaped it on the way out, `.text()` DECODED it on the way back in, and jQuery then
// parses the result as HTML. Six sites did that and one escaped. `U-38` was the same shape and shipped as a
// live stored XSS.
//
// 🔑 **Explicit entities rather than `$('<span>').text(x).html()`, and the difference is load-bearing.** That
// jQuery idiom — which is what the one correct site used — serialises a text node, so it escapes `&`, `<`
// and `>` and **not quotes**. That is right for element content and WRONG for an attribute: `laatu.js`
// interpolates a DOM-read value into `data-modal-user="…"`, where an unescaped `"` closes the attribute.
// Escaping quotes is harmless in content (the browser renders `&quot;` as `"`), so one function is correct
// in both contexts and nobody has to decide which they are in.
//
// ⚠️ **One regex pass, `&` included in the same alternation**, so `&` is never double-escaped: a
// replace-`&`-then-replace-`<` sequence turns `&lt;` into `&amp;lt;`.
//
// 📌 **Prefer not needing this at all.** A value that is simply element content or an attribute should be
// set AFTER the markup is inserted — `.text(value)` / `.attr(name, value)` — which is safe by construction.
// This exists for the case where the value has to sit INSIDE a translated string, e.g.
// `I18n.t('delete_modal.body_with_name', { name: '<strong>' + escapeHtml(target) + '</strong>' })`.
// 📌 Dependency-free on purpose: no jQuery, no DOM node, so it is usable from any module and testable.
const HTML_ENTITIES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
}

export default function escapeHtml(value) {
  if (value === null || value === undefined) return ''

  return String(value).replace(/[&<>"']/g, character => HTML_ENTITIES[character])
}
